import { Dispatch, SetStateAction } from "react";
import { NavigateFunction } from "react-router-dom";
import store, { actions } from "../../redux";
import { API_STATUS } from "../../redux/common";
import { ArticleProps } from "../../redux/slices/article/Article";
import { ROUTES } from "../../utills/routes";
import { API_INSTANCES } from "../api_instance";
import { handleError } from "../errors";

const dispatch = store.dispatch;

const createOrUpdateArticleContent = (
  payload: ArticleProps.createOrUpdateArticleContentPayload,
  setApi_status?: Dispatch<SetStateAction<API_STATUS>>
) => {
  setApi_status && setApi_status("progress");
  return API_INSTANCES.ARTICLE.createOrUpdateArticleContent(payload)
    .then((response) => {
      const data = response.data as ArticleProps.Content;
      dispatch(actions.article.setArticleContent(data));
      setApi_status && setApi_status("success");
    })
    .catch((error) => {
      handleError(error, "createOrUpdateArticleContent");
      setApi_status && setApi_status("error");
    });
};

const deleteASingleArticleContent = (id: number) => {
  API_INSTANCES.ARTICLE.deleteASingleArticleContent(id)
    .then((response) => {
      const data = response.data as ArticleProps.Article;
      dispatch(actions.article.setArticleDraft(data));
    })
    .catch((error) => {
      handleError(error, "deleteASingleArticleContent");
    });
};

const createArticleDraft = () => {
  dispatch(actions.article.setCreateDraftAPI_STATUS("progress"));
  API_INSTANCES.ARTICLE.createArticleDraft()
    .then((response) => {
      const data = response.data as ArticleProps.Article;
      dispatch(actions.article.setArticleDraft(data));
      dispatch(actions.article.setCreateDraftAPI_STATUS("success"));
    })
    .catch((error) => {
      dispatch(actions.article.setCreateDraftAPI_STATUS("error"));
      handleError(error, "createArticleDraft");
    });
};

const deleteArticleDraft = (post_id: string) => {
  return API_INSTANCES.ARTICLE.deleteArticleDraft(post_id)
    .then(() => {
      dispatch(actions.article.deleteArticleDraft(post_id));
      dispatch(actions.article.deletePublishedArticleDraft(post_id));
      dispatch(actions.article.deleteScheduledArticleDraft(post_id));
    })
    .catch((error) => {
      handleError(error, "deleteArticleDraft");
    });
};

const reorderArticleEntries = (
  payload: ArticleProps.reorderArticleEntriesPayload
) => {
  API_INSTANCES.ARTICLE.reorderArticleEntries(payload)
    .then((response) => {
      const data = response.data as ArticleProps.Article;
      dispatch(actions.article.setArticleDraft(data));
    })
    .catch((error) => {
      handleError(error, "reorderArticleEntries");
    });
};

const listArticleDrafts = () => {
  API_INSTANCES.ARTICLE.listArticleDrafts()
    .then((response) => {
      const data = response.data as ArticleProps.ArticleListItem[];
      dispatch(actions.article.setArticleDraftList(data));
    })
    .catch((error) => {
      handleError(error, "listArticleDrafts");
    });
};

const listScheduledArticles = () => {
  API_INSTANCES.ARTICLE.listScheduledArticles()
    .then((response) => {
      const data = response.data as ArticleProps.ArticleListItem[];
      dispatch(actions.article.setArticleScheduledList(data));
    })
    .catch((error) => {
      handleError(error, "listScheduledArticles");
    });
};

const listPublishedArticles = () => {
  API_INSTANCES.ARTICLE.listPublishedArticles()
    .then((response) => {
      const data = response.data as ArticleProps.ArticleListItem[];
      dispatch(actions.article.setArticlePublishedList(data));
    })
    .catch((error) => {
      handleError(error, "listPublishedArticles");
    });
};

const getASingleArticleDraft = (
  post_id: string,
  navigate?: NavigateFunction
) => {
  dispatch(actions.article.setCreateDraftAPI_STATUS("progress"));
  API_INSTANCES.ARTICLE.getASingleArticleDraft(post_id)
    .then((response) => {
      const data = response.data as ArticleProps.Article;
      dispatch(actions.article.setArticleDraft(data));
      dispatch(actions.article.setCreateDraftAPI_STATUS("success"));
    })
    .catch((error) => {
      navigate && navigate(ROUTES.article);
      dispatch(actions.article.setCreateDraftAPI_STATUS("error"));
      handleError(error, "getASingleArticleDraft");
    });
};

const publishArticleDraft = (post_id: string, scheduled_data?: string) => {
  return API_INSTANCES.ARTICLE.publishArticleDraft(post_id, scheduled_data)
    .then(() => {})
    .catch((error) => {
      handleError(error, "publishArticleDraft");
    });
};

const rescheduleAScheduledArticleDraft = (
  post_id: string,
  scheduled_data: string
) => {
  return API_INSTANCES.ARTICLE.rescheduleAScheduledArticleDraft(
    post_id,
    scheduled_data
  )
    .then(() => {})
    .catch((error) => {
      handleError(error, "rescheduleAScheduledArticleDraft");
    });
};

const duplicateAnArticleDraftAsANewDraft = (
  post_id: string,
  navigate: NavigateFunction
) => {
  API_INSTANCES.ARTICLE.duplicateAnArticleDraftAsANewDraft(post_id)
    .then((response) => {
      const data = response.data as ArticleProps.Article;
      navigate(ROUTES.article + `?article_id=${data.post_id}`);
    })
    .catch((error) => {
      handleError(error, "duplicateAnArticleDraftAsANewDraft");
    });
};

const uploadAudioForArticleDraft = (
  payload: ArticleProps.uploadAudioForArticleDraftPayload,
  setUploadAudioAPI_STATUS: Dispatch<SetStateAction<API_STATUS>>
) => {
  setUploadAudioAPI_STATUS("progress");
  API_INSTANCES.ARTICLE.uploadAudioForArticleDraft(payload)
    .then((response) => {
      const data = response.data as ArticleProps.Content;
      dispatch(actions.article.setArticleContent(data));
      setUploadAudioAPI_STATUS("success");
    })
    .catch((error) => {
      handleError(error, "uploadAudioForArticleDraft");
      setUploadAudioAPI_STATUS("error");
    });
};

const deleteArticleAudio = (
  payload: ArticleProps.deleteArticleAudioPayload
) => {
  API_INSTANCES.ARTICLE.deleteArticleAudio(payload)
    .then(() => {})
    .catch((error) => {
      handleError(error, "deleteArticleAudio");
    });
};

const uploadAudioBackground = (
  payload: ArticleProps.uploadAudioBackgroundPayload
) => {
  API_INSTANCES.ARTICLE.uploadAudioBackground(payload)
    .then((response) => {
      const data = response.data as ArticleProps.Content;
      dispatch(actions.article.setArticleContent(data));
    })
    .catch((error) => {
      handleError(error, "uploadAudioBackground");
    });
};

const deleteArticleAudioImage = (
  payload: ArticleProps.deleteArticleAudioImagePayload
) => {
  return API_INSTANCES.ARTICLE.deleteArticleAudioImage(payload)
    .then(() => {})
    .catch((error) => {
      handleError(error, "deleteArticleAudioImage");
    });
};

const uploadVideoForArticleDraft = (
  payload: ArticleProps.uploadVideoForArticleDraftPayload,
  setUploadVideoAPI_STATUS: Dispatch<SetStateAction<API_STATUS>>
) => {
  setUploadVideoAPI_STATUS("progress");
  API_INSTANCES.ARTICLE.uploadVideoForArticleDraft(payload)
    .then((response) => {
      const data = response.data as ArticleProps.Content;
      dispatch(actions.article.setArticleContent(data));
      setUploadVideoAPI_STATUS("success");
    })
    .catch((error) => {
      handleError(error, "uploadVideoForArticleDraft");
      setUploadVideoAPI_STATUS("error");
    });
};

const deleteVideoFromAArticle = (
  payload: ArticleProps.deleteVideoFromAArticlePayload
) => {
  return API_INSTANCES.ARTICLE.deleteVideoFromAArticle(payload)
    .then(() => {})
    .catch((error) => {
      handleError(error, "deleteVideoFromAArticle");
    });
};

const deleteAnArticleImage = (id: string, order_id: number) => {
  return API_INSTANCES.ARTICLE.deleteAnArticleImage(id)
    .then(() => {
      dispatch(
        actions.article.deleteArticleImage({ image_id: id, id: order_id })
      );
    })
    .catch((error) => {
      handleError(error, "deleteAnArticleImage");
    });
};

const reorderImagesInAnImageBlock = (
  post_article_id: number,
  image_ids: string[]
) => {
  return API_INSTANCES.ARTICLE.reorderImagesInAnImageBlock(
    post_article_id,
    image_ids
  )
    .then(() => {})
    .catch((error) => {
      handleError(error, "reorderImagesInAnImageBlock");
    });
};
export const ARTICLE = {
  //common
  createOrUpdateArticleContent,
  deleteASingleArticleContent,
  createArticleDraft,
  deleteArticleDraft,
  reorderArticleEntries,
  listArticleDrafts,
  getASingleArticleDraft,
  listPublishedArticles,
  listScheduledArticles,
  publishArticleDraft,
  duplicateAnArticleDraftAsANewDraft,
  rescheduleAScheduledArticleDraft,

  //audio
  uploadAudioForArticleDraft,
  deleteArticleAudio,
  uploadAudioBackground,
  deleteArticleAudioImage,

  //video
  uploadVideoForArticleDraft,
  deleteVideoFromAArticle,

  //images
  deleteAnArticleImage,
  reorderImagesInAnImageBlock,
};
